import InstitutionHomePage from '../pages/institution/home'
import InstitutionDashboardPage from '../pages/institution/dashboard'
import InstitutionProfileDetailsPage from '../pages/institution/profile/details'
import InstitutionChangePasswordPage from '../pages/institution/changePassword'
import InstitutionProfileEditPage from '../pages/institution/profile/edit'
import InstitutionDocumentsPage from '../pages/institution/documents'
import InstitutionLabTestsPage from '../pages/institution/labTests'
import InstitutionLabTestFormPage from '../pages/institution/labTests/form/test'
import InstitutionLabPackageFormPage from '../pages/institution/labTests/form/package'
import InstituteHealthServicesPage from '../pages/institution/healthServices'
import InstituteHealthServiceFormPage from '../pages/institution/healthServices/form'
import InstituteStaffsPage from '../pages/institution/staffs'
import InstituteHealthProviderFormPage from '../pages/institution/staffs/healthcareProviders/form'
import InstituteDoctorFormPage from '../pages/institution/staffs/doctors/form'
import InstitutionChatsPage from '../pages/institution/chats'
import InstituteTalkToSupportPage from '../pages/institution/talkToSupport'
import InstituteTransactionsPage from '../pages/institution/transactions'
import InstituteAppointmentsPage from '../pages/institution/appointments'
import InstituteAppointmentFormPage from '../pages/institution/appointments/form'
import InstituteAppointmentDetailsPage from '../pages/institution/appointments/details'
const routes = [
  {
    Component: InstitutionHomePage,
    exact: true,
    index: true,
  },
  {
    Component: InstitutionDashboardPage,
    exact: true,
    path: 'dashboard',
  },
  {
    Component: InstitutionChatsPage,
    exact: true,
    path: 'chats',
  },
  {
    Component: InstitutionProfileDetailsPage,
    exact: true,
    path: 'profile',
  },

  {
    Component: InstitutionProfileEditPage,
    exact: true,
    path: 'profile/edit',
  },
  {
    Component: InstitutionChangePasswordPage,
    exact: true,
    path: 'change-password',
  },
  {
    Component: InstitutionDocumentsPage,
    exact: true,
    path: 'documents',
  },
  {
    Component: InstitutionLabTestsPage,
    exact: true,
    path: 'lab-tests',
  },
  {
    Component: InstitutionLabTestFormPage,
    exact: true,
    path: 'lab-tests/create',
  },
  {
    Component: InstitutionLabTestFormPage,
    exact: true,
    path: 'lab-tests/:slug',
  },
  {
    Component: InstitutionLabPackageFormPage,
    exact: true,
    path: 'lab-packages/create',
  },
  {
    Component: InstitutionLabPackageFormPage,
    exact: true,
    path: 'lab-packages/:slug',
  },
  {
    Component: InstituteHealthServicesPage,
    exact: true,
    path: 'health-services',
  },
  {
    Component: InstituteHealthServiceFormPage,
    exact: true,
    path: 'health-services/create',
  },
  {
    Component: InstituteHealthServiceFormPage,
    exact: true,
    path: 'health-services/:slug',
  },
  {
    Component: InstituteStaffsPage,
    exact: true,
    path: 'staffs',
  },
  {
    Component: InstituteHealthProviderFormPage,
    exact: true,
    path: 'staffs/health-provider',
  },
  {
    Component: InstituteHealthProviderFormPage,
    exact: true,
    path: 'staffs/health-provider/:slug',
  },
  {
    Component: InstituteDoctorFormPage,
    exact: true,
    path: 'staffs/doctor',
  },
  {
    Component: InstituteDoctorFormPage,
    exact: true,
    path: 'staffs/doctor/:slug',
  },
  {
    Component: InstituteTalkToSupportPage,
    exact: true,
    path: 'talk-to-support',
  },
  {
    Component: InstituteTransactionsPage,
    exact: true,
    path: 'transactions',
  },
  {
    Component: InstituteAppointmentsPage,
    exact: true,
    path: 'appointments',
  },
  {
    Component: InstituteAppointmentFormPage,
    exact: true,
    path: 'appointments/create',
  },
  {
    Component: InstituteAppointmentDetailsPage,
    exact: true,
    path: 'appointments/:slug',
  },
]

export default routes
